import { fromJS } from 'immutable';
import * as metricTypes from 'reporting-data/constants/metricTypes';
import * as sortOrder from 'reporting-data/constants/sortOrder';
export const AVERAGE_TIME_ON_PAGE = fromJS({
  property: 'averageTimeOnPage',
  metricTypes: [metricTypes.PERCENTILES]
});
export const HELPFUL_FEEDBACK_COUNT = fromJS({
  property: 'helpfulFeedback',
  metricTypes: [metricTypes.COUNT]
});
export const SORT_BY_VIEWS_DESC = fromJS({
  order: sortOrder.DESC,
  property: 'rawViews'
});
export const SORT_BY_SEARCHES_DESC = fromJS({
  order: sortOrder.DESC,
  property: 'totalSearches'
});
export const TIME_PER_ARTICLE_METRIC = fromJS({
  property: 'timePerPageview',
  metricTypes: [metricTypes.PERCENTILES]
});
export const UNHELPFUL_FEEDBACK_COUNT = fromJS({
  property: 'unhelpfulFeedback',
  metricTypes: [metricTypes.COUNT]
});
export const VIEWS_METRIC = fromJS({
  property: 'rawViews',
  metricTypes: [metricTypes.SUM]
});